// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Ffbc","title":"AfterFrontImage_title__3Ins7"};